import React, { useState } from "react";
import { Alert, Box, Button, CircularProgress, List, ListItemButton, ListItemText, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useSiteGroups } from "./useSiteGroups";
import { SiteGroupDialog } from "./SiteGroupDialog";

/**
 * The organization's collection-site groups: zones, districts, whatever areas
 * it reports by. Reports filter by them and can group sites by them.
 */
export const SiteGroups = () => {
  const { groups, sites, loading, error, save, remove } = useSiteGroups();
  const [editing, setEditing] = useState(null);
  const nameOf = (id) => sites.find((s) => s.id === String(id))?.name;

  return (
    <Box sx={{ p: 2 }} id="site-groups">
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, mb: 1.5 }}>
        <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>
          Group collection sites into zones or districts to filter and summarize reports by them.
        </Typography>
        <Button size="small" startIcon={<AddIcon />} onClick={() => setEditing({})} sx={{ flexShrink: 0 }}>
          New group
        </Button>
      </Box>
      {error && <Alert severity="error">{error}</Alert>}
      {loading ? (
        <CircularProgress size={24} sx={{ m: 2 }} />
      ) : groups.length === 0 ? (
        <Typography color="text.secondary" sx={{ py: 2 }}>
          No site groups yet.
        </Typography>
      ) : (
        <List dense disablePadding aria-label="Site groups" sx={{ border: 1, borderColor: "divider", borderRadius: 1 }}>
          {groups.map((g) => {
            const names = g.trapSiteIds.map(nameOf).filter(Boolean);
            return (
              <ListItemButton key={g.id} divider onClick={() => setEditing(g)}>
                <ListItemText
                  primary={g.name}
                  secondary={
                    names.length
                      ? `${names.length} site${names.length === 1 ? "" : "s"}: ${names.join(", ")}`
                      : "No sites yet"
                  }
                  secondaryTypographyProps={{ noWrap: true }}
                />
              </ListItemButton>
            );
          })}
        </List>
      )}
      <SiteGroupDialog
        open={Boolean(editing)}
        group={editing?.id ? editing : null}
        sites={sites}
        onClose={() => setEditing(null)}
        onSave={save}
        onDelete={remove}
      />
    </Box>
  );
};
